export default __webpack_public_path__ + "static/media/btn-videos.8371322e.webp";